var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-info",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.onSearchTaxData}},[_c('b-icon',{attrs:{"icon":"search"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }